import React, { useState, useEffect } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash, FaEye, FaCalendarAlt, FaBars, FaBorderAll } from "react-icons/fa";
// import { useUserContext } from '../context/DealerProfile.jsx'
import { TfiMenuAlt } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../context/DealerProfile.jsx";
import { Link } from "react-router-dom";
// import { Pagination } from "flowbite-react";
// Paste this once in your component file or extract to its own file

const SimplePagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    return (
        <div className="flex flex-wrap justify-center items-center gap-2 mt-4">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Previous
            </button>


            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Next
            </button>
        </div>
    );
};





export default function LeadsTable() {
    const { dealerDetail, error } = useUserContext();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [leads, setLeads] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [openDropdown, setOpenDropdown] = useState(null);  // Track open dropdown
    const [formData, setFormData] = useState({}); // Store lead form data
    const [editingId, setEditingId] = useState(null);
    const [tasks, setTasks] = useState([]);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Open modal
    // Open modal and save current state before changes
    const openModal = () => {
        setPrevSelectedColumns(selectedColumns); // Save current state before changes
        setIsModalOpen(true);
    };

    const columns = [
        {
            name: "Script Document Name",
            // selector returns plain string for sorting
            selector: row => row.Name ?? "",
            // cell renders clickable styled span
            cell: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/script-details/${row.id}`)}
                >
                    {row?.Name}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "200px",
        },
      
    ];



    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([]);


    // State to track the most recently clicked column
    const [lastClickedColumn, setLastClickedColumn] = useState(null);
    const [initialColumns, setInitialColumns] = useState([]); // Track initial columns state


    // Fetch columns from localStorage or default columns when component mounts
    useEffect(() => {
        const storedColumns = localStorage.getItem("selectedColumns");

        if (storedColumns) {
            // If columns are found in localStorage, use them
            const parsedColumns = JSON.parse(storedColumns);
            setSelectedColumns(parsedColumns);
            setInitialColumns(parsedColumns); // Save the initial state
        } else {
            // Otherwise, use default columns (this is assuming 'columns' is your default set)
            const defaultColumns = columns.map(col => col.name);
            setSelectedColumns(defaultColumns);
            setInitialColumns(defaultColumns); // Save the initial state
        }
    }, []);

    // Function to handle column changes
    const handleColumnChange = (colName) => {
        setSelectedColumns((prev) => {
            const updatedColumns = prev.includes(colName)
                ? prev.filter((name) => name !== colName)
                : [...prev, colName];

            try {
                // Ensure only primitive values (strings) are stored
                const safeColumns = updatedColumns.map(col => String(col));
                localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
            } catch (error) {
                // console.error("Error saving to localStorage:", error);
            }

            // Track the most recent checkbox clicked
            setLastClickedColumn(colName);

            return updatedColumns;
        });
    };


    // Function to apply filters (save to localStorage)
    const applyFilter = () => {
        try {
            // Ensure only primitive values (strings) are stored
            const safeColumns = selectedColumns.map(col => String(col));
            localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
        } catch (error) {
            // console.error("Error saving to localStorage:", error);
        }

        setIsModalOpen(false);
    };

    const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state



    // Function to reset filter by restoring the saved state
    const resetFilter = () => {
        setSelectedColumns(prevSelectedColumns); // Restore previous selection
        setIsModalOpen(false);
    };


    const filteredColumns = columns.filter(
        col => selectedColumns.includes(col.name) || typeof col.name === "object"
    );







    const [isFetched, setIsFetched] = useState(false);

    useEffect(() => {
        const fetchLeadValues = async () => {
            setIsLoading(true); // Start loading
            try {
                const response = await fetch(
                    "/server/dealer_backend/getAllScripts",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            dealerEmail: dealerDetail?.Email,
                        }),
                    }
                );

                const data = await response.json();

                //    console.log(data)
                if (data.status === "success") {
                    // ✅ Filter leads that match dealer's email


                    //   console.log(filteredLeads)
                    setLeads(data.data);
                } else {
                    // console.error("Failed to fetch calls:", data.error);
                    setLeads([]); // Ensure leads is set even on error
                }
            } catch (error) {
                // console.error("Error fetching calls:", error);
                setLeads([]); // Avoid leads being undefined
            } finally {
                setIsLoading(false); // End loading
                setIsFetched(true);  // Mark fetch as complete
            }
        };


        fetchLeadValues();

    }, []);



    const totalPages = Math.ceil(leads.length / rowsPerPage);
    const onPageChange = (page) => setCurrentPage(page);
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };



    const handleView = (rowData, field) => {

        navigate(`/owner-details/${rowData.id}`);

    };



    const handleEditClick = async (rowData) => {
        // setFormData(rowData); // Populate form with existing data before editing
        // setEditingId(rowData.id); // Store the ID of the lead being edited
        navigate(`/-edit/${rowData.id}`);
    };










    function useIsMobile(breakpoint = 768) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, [breakpoint]);

        return isMobile;
    }



    function MobileDonorCard({ donor }) {
        return (
            <Link to={`/script-details/${donor.id}`}>
                <div className="bg-white shadow-md rounded-xl p-4 mb-4 w-[28%] hover:bg-gray-50 transition cursor-pointer">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
                                {`${donor.Name ?? ''}`.trim().charAt(0) || 'D'}

                            </div>
                            <div>
                                <p className="font-semibold text-gray-900"> {`${donor.Name || ''}`.trim()}</p>
                                <p className="text-xs text-gray-500">{donor.id}</p>
                            </div>
                        </div>

                    </div>

                    <hr className="my-2" />

                    <div className="text-sm text-gray-700">
                        <div className="flex justify-between mb-1">
                            {/* <span className="text-gray-500">Description</span>
                            <span>{donor.Script_Description || 'N/A'}</span> */}
                        </div>

                    </div>
                </div>
            </Link>
        );
    }




    const isMobile = useIsMobile();





    return (
        <div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-[300px]" onClick={(e) => e.stopPropagation()}>
                        <h2 className="text-xl font-bold mb-4">Manage Columns</h2>

                        {/* Search Box */}
                        <input
                            type="text"
                            placeholder="Search"
                            className="w-full p-2 border rounded mb-2"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        {/* Column Selection */}
                        {/* Column Selection */}
                        <div className="max-h-60 overflow-auto">
                            {columns
                                .filter(col => typeof col.name === "string")
                                .filter(col => col.name.toLowerCase().includes(searchTerm.toLowerCase()))
                                .map((col, index) => {
                                    const isLastName = col.name === "Last Name";
                                    return (
                                        <label key={index} className="flex items-center mb-2">
                                            <input
                                                type="checkbox"
                                                checked={selectedColumns.includes(col.name)}
                                                onChange={() => {
                                                    if (!isLastName) {
                                                        handleColumnChange(col.name);
                                                    }
                                                }}
                                                disabled={isLastName} // Prevent deselection
                                                className="mr-2"
                                            />
                                            {col.name}
                                        </label>
                                    );
                                })}
                        </div>



                        {/* Buttons */}
                        <div className="flex justify-end mt-4 gap-2">
                            <button className="px-4 py-2 bg-red-500 text-white rounded" onClick={resetFilter}>Cancel</button>
                            <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={applyFilter}>Save</button>
                        </div>
                    </div>
                </div>
            )}


            <h2 className="table-title"></h2>
            <div className="leads-content">
                {/* <h2 className="mr-[52.2rem] mt-[10px] font-bold text-xl">Leads</h2> */}
                <div className="table-header flex justify-between items-center p-4">



                    {/* FaBars icon button */}





                    {/* Add Lead button */}
                    {/* <button
                        onClick={() => navigate("/create-lead")}
                        className="create-button bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition"
                    >
                        Add Lead
                    </button> */}
                </div>





                {/* Show Loading */}
                {isLoading ? (
                    <div className="loading-circle flex justify-center items-center gap-2 py-6 text-blue-500">
                        <svg
                            className="animate-spin h-5 w-5 text-blue-500"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                        <span>Loading Data...</span>
                    </div>

                ) : leads.length === 0 ? (
                    <div className="text-center py-6 text-blue-500">No data available</div>
                ) : (
                    isMobile ? (
                        <div className="px-4">
                            {leads.map((donor, index) => (
                                <MobileDonorCard key={index} donor={donor} />
                            ))}
                        </div>
                    ) : (
                        <>
                            <div className="w-[70rem] overflow-auto">
                                <DataTable
                                    columns={columns}
                                    data={leads.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)}
                                   fixedHeader
                                    dense
                                    responsive
                                    highlightOnHover
                                    progressPending={isLoading}
                                    className="custom-table text-base"
                                    onRowClicked={(row) => navigate(`/script-details/${row.id}`)}
                                    customStyles={{
                                        headCells: { style: { fontSize: "16px", fontWeight: "700", background: "#F3F7FA", color: "#1e3a8a" } },
                                        cells: { style: { whiteSpace: "nowrap", overflow: "visible", fontSize: "15px" } },
                                        rows: {
                                            style: {
                                                transition: "background 0.2s",
                                                "&:hover": { background: "#ebf4ff" },
                                            },
                                        },
                                    }}
                                    style={FaBorderAll}
                                />
                            </div>


                            {/* Show Pagination only when leads are loaded */}
                            <div className="mr-[2rem] table-footer mt-4 flex flex-wrap justify-between items-center">
                                <span className="pagination-info">
                                    {`Showing ${Math.min(
                                        (currentPage - 1) * rowsPerPage + 1,
                                        leads.length
                                    )} 
      to ${Math.min(currentPage * rowsPerPage, leads.length)} 
      of ${leads.length} Entries`}
                                </span>

                                <span className="rows-per-page flex items-center gap-2">
                                    <label className="text-gray-700 font-medium">Records per page</label>
                                    <select
                                        value={rowsPerPage}
                                        onChange={handleRowsPerPageChange}
                                        className="border rounded px-1 text-gray-700 focus:outline-none"
                                    >
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={250}>250</option>
                                    </select>
                                </span>

                                <SimplePagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={onPageChange}
                                />
                            </div>

                        </>
                    )
                )}

            </div>




        </div>
    );
}
